"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        table: function (_a) {
            var hasData = _a.hasData, loading = _a.loading, variant = _a.variant, height = _a.height, offsetHeight = _a.offsetHeight;
            // when fixed we set height to a fixed number, otherwise use calc with an offsetHeight
            var variantHeight = variant === 'fixed' && !offsetHeight ? height : "calc(100vh - ".concat(offsetHeight, ")");
            return {
                // if data is empty or loading we can use auto height
                height: loading || !hasData || !offsetHeight ? 'auto' : variantHeight,
                width: '100%',
                maxWidth: '100%',
                overflowX: 'scroll',
                '&-ms-overflow-style': 'none',
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': {
                    display: 'none',
                },
            };
        },
        list: function (_a) {
            var loadMoreIndicatorSize = _a.loadMoreIndicatorSize, loading = _a.loading, minTableWidth = _a.minTableWidth, listPadding = _a.listPadding;
            return ({
                height: loading ? "calc(100% - ".concat(loadMoreIndicatorSize, "px)") : '100%',
                width: '100%',
                maxWidth: '100%',
                minWidth: minTableWidth || theme.breakpoints.values.md || '960px',
                overflowY: 'auto',
                overflowX: 'unset',
                paddingBottom: listPadding ? "".concat(listPadding, "px") : '200px',
                '&-ms-overflow-style': 'none',
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': {
                    display: 'none',
                },
            });
        },
        loadingMoreRow: function (_a) {
            var itemSize = _a.itemSize;
            return ({
                display: 'flex',
                height: itemSize,
                justifyContent: 'center',
                alignItems: 'center',
                maxWidth: '100%',
            });
        },
        // FIXME:
        // this is a component. nothing specific to an entity should be included in generics
        rfiList: function (_a) {
            var _b = _a.rfiListOverFlow, rfiListOverFlow = _b === void 0 ? { overflow: 'unset', height: 'unset' } : _b;
            return ({
                overflow: rfiListOverFlow.overflow,
                height: rfiListOverFlow.height,
            });
        },
    });
});
